import { IShortcut } from 'schemas';

export type TGameAccountsGroup = {
  id: number;
  title: string;
  launcher: ELauncher;
  accounts: Array<TGameAccount>;
  shortcuts: Array<IShortcut>;
};

export type TGameAccount = {
  id: number;
  login: string;
  group: Pick<TGameAccountsGroup, 'id' | 'title'>;
  password?: string;
  active?: boolean;
  status?: EGameAccountStatus;
  busy?: boolean;
  host?: {
    id: number;
    alias: string;
    group_id: number;
  };
  assignment?: {
    host: {
      id: number;
      alias: string;
      group_id: number;
    };
  };
};

enum EGameAccountStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  IN_GAME = 'IN_GAME',
}
export enum ELauncher {
  STEAM = 'STEAM',
  EGS = 'EGS',
  BATTLE_NET = 'BATTLENET',
  EA = 'EA',
}
